import React from 'react';
import { QButton, QButtonGroup, QStack } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { PermissionsFormElements } from '../../../components/permissions/PermissionsFormElements';

type PermissionsSectionProps = {
  isDisabled: boolean;
  isLoading: boolean;
  resetPermissions: () => void;
  onCancel: () => void;
};

export const PermissionsSection: React.FC<PermissionsSectionProps> = ({
  isLoading,
  isDisabled,
  resetPermissions,
  onCancel,
}) => {
  const { t } = useTranslation();
  return (
    <QStack direction={['column']} spacing={6}>
      <PermissionsFormElements resetPermissions={resetPermissions} isHumanUser />
      <QButtonGroup>
        <QButton data-cy="cancel-button" variant="outline" onClick={onCancel}>
          {t('common.cancel')}
        </QButton>
        <QButton data-cy="save-changes" isLoading={isLoading} isDisabled={isDisabled} size="sm" type="submit">
          {t('permissions.saveChanges')}
        </QButton>
      </QButtonGroup>
    </QStack>
  );
};
